import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../../maincomponent/reacttable/table";
import { doctimeslot } from "../../../text/apidata";
import axios from "axios";
import "../../style/page/tabs/timeslot.scss";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import DateFnsUtils from "@date-io/date-fns";
import { useDispatch ,useSelector } from "react-redux";

import dayjs from "dayjs";

function TimeSlot(props) {
  const doctor = useNavigate();
  const editdoctorid = useSelector((state) => state.counter.edituserdoctorid);

  var date = new Date(),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  // console.log([date.getFullYear(), mnth, day].join("-"));
  var date = [date.getFullYear(), mnth, day].join("-");
  // console.log(date, "data");

  const [currentdate, setcurrentdate] = useState(date);

  let array1 = [];
  const current = new Date();
  const [slotarray, setslotarray] = useState([]);
  const [test, settest] = useState([]);
  const [tableheaderdata, settableheaderdata] = useState([]);
  useEffect(() => {
    // var date = new Date(),
    //   mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    //   day = ("0" + date.getDate()).slice(-2);
    // console.log([date.getFullYear(), mnth, day].join("-"));
    // var date = [date.getFullYear(), mnth, day].join("-");
    // console.log(date,"data");
    // setcurrentdate(String(date));
  }, []);

  useEffect(() => {
    props.loaderchange("true");
    setTimeout(() => {
      if (currentdate != undefined) {
        props.loaderchange("true");
        axios({
          method: "get",
          url: doctimeslot + currentdate,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          
          params: {
            doctor_id: editdoctorid,
          },
    
        })
          .then((res) => {
            settest(res.data.data);
            res.data.data.map((element) => {
              //   console.log(element.slot);
              setslotarray((prev) => [...prev, element.slot]);
            });
            // const numAscending = [...res.data.data].sort((a, b) => a.day - b.day);
            // console.log(numAscending);

            settableheaderdata(res.data.data);
            props.loaderchange("false")
          })
          .catch((error) => {
            // alert("kjhk")
            console.log(error);
            settableheaderdata([]);
            props.loaderchange("false")

          });
      }
    }, 500);
  }, [editdoctorid, currentdate]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    setcurrentdate(value.slice(0, 10));
    // let result = value.replaceAll('/','-');


    // console.log(currentdate)
  };
  const routeback=()=>{

    doctor("/Doctor");

  }
  return (
    <>
      <div className="maincontainer_time">
        <div className="timeslot_v">
          <div className="table-content-timeslot">
            <div className="table-timeslot">
              {/* <BasicTable columns={columns} data={tableheaderdata} /> */}
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col">
                      <div class="text-left mt-3 px-3 py-1 mx-1">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={dayjs(currentdate)}
                             format="DD-MM-YYYY"

                            onChange={(newValue) => {
                              var dateobj = new Date(newValue["$d"]);
                              var datetimeISOformat = dateobj.toISOString();
                              // console.log(datetimeISOformat,
                              //   dateobj,newValue["$d"],"1234")
                              var tzoffset =
                                new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                              var localISOTime = new Date(dateobj - tzoffset)
                                .toISOString()
                                .slice(0, -1);

                                // console.log(localISOTime,"lt")
                              handlechangedate(
                                "validtill",
                                // datetimeISOformat,
                                // dateobj
                                localISOTime
                              );
                              // setcurrentdate(datetimeISOformat.slice(0, 10));
                            }}
                          />
                        </LocalizationProvider>
                      </div>{" "}
                    </div>
                    <div class="col">
                      <div
                        class="row"
                        style={{ float: "right", padding: "20px" }}
                      >
                        <div class="color1"></div>
                        <p class="col">Not Available</p>
                      </div>
                      <div
                        class="row"
                        style={{ float: "right", padding: "20px" }}
                      >
                        <div class="color2"></div>
                        <p class="col">Available</p>
                      </div>
                    </div>
                  </div>

                  <div class="token-slot mt-5">
                    <Box sx={{ flexGrow: 1 }}>
                      {tableheaderdata.length > 0 &&
                        tableheaderdata.map((time) => {
                          return (
                            <>
                              <button
                                class="h4  "
                                style={{
                                  color:
                                    time.status == "0"
                                      ? "green"
                                      : time.status == "1"
                                      ? "black"
                                      : time.status == "2"
                                      ? "black"
                                      : "",
                                  fontWeight: 700,
                                  border:
                                    time.status == "0"
                                      ? "1px solid green"
                                      : time.status == "1"
                                      ? "1px solid gray"
                                      : time.status == "2"
                                      ? "1px solid gray"
                                      : "",
                                  backgroundColor:
                                    time.status == "0"
                                      ? "white"
                                      : time.status == "1"
                                      ? "gray"
                                      : time.status == "2"
                                      ? "gray"
                                      : "",
                                  width: "100px",
                                  marginLeft: "20px",
                                  borderRadius: "7px",
                                  fontSize: "16px",
                                  padding: "7px",
                                }}
                              >
                                {String(time.slot).slice(0, -3)}
                              </button>
                            </>
                          );
                        })||<p style={{fontSize: "20px",position: "relative",width: "1000px",top: "80px",margin: "auto",textAlign: "center"}}>Doctor not available</p>}
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TimeSlot;
